import { render, staticRenderFns } from "./AutoHelp.vue?vue&type=template&id=66b32500&scoped=true&"
import script from "./AutoHelp.vue?vue&type=script&lang=js&"
export * from "./AutoHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b32500",
  null
  
)

export default component.exports